import styled, { css } from 'styled-components';

export const AlertContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  justify-content: center;
`;
export const AlertContent = styled.div<{
  paddingBottom: boolean;
}>`
  box-sizing: border-box;
  width: 100%;
  ${({ paddingBottom }) => css`
    padding-bottom: ${paddingBottom ? ' 8px' : '0px'};
  `}
`;
export const AlertTop = styled.div`
  align-items: center;
  border-radius: 15px 15px 0 0;
  display: flex;
  font-size: 1.5rem;
  font-weight: 400;
  justify-content: center;
  padding-top: 24px;
  text-align: center;
`;
export const AlertBottom = styled.div`
  align-items: center;
  border-radius: 0 0 15px 15px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  margin-top: 24px;
  padding: 0px 16px;
  width: 100%;
`;

export const AlertTitle = styled.div<{
  isMobile: boolean;
}>`
  ${({ isMobile }) => css`
    font-size: 20px;
    font-weight: 800;
    text-align: center;
    white-space: pre-line;
    margin-top: ${isMobile ? '24px' : '0'};
  `}
`;

export const AlertBody = styled.div<{
  isMobile: boolean;
}>`
  font-size: 16px;
  font-weight: normal;
  text-align: center;
  white-space: pre-line;
  margin-top: 8px;
  margin-bottom: 16px;
`;

export const AlertAction = styled.div<{
  isMobile: boolean;
}>`
  ${({ isMobile }) => css`
    align-items: center;
    box-sizing: border-box;
    display: flex;
    flex-direction: ${isMobile ? 'column-reverse' : 'row'};
    justify-content: center;
    margin-top: 24px;
    padding: 0px ${isMobile ? '20px' : '0px'};
    width: 100%;
    text-align: center;
  `}
`;

export const ButtonContainer = styled.div<{
  isMobile: boolean;
}>`
  flex: 1;
  width: 100%;
  margin-bottom: 8px;
  ${({ isMobile }) => css`
    max-width: ${isMobile ? '100%' : '50%'};
    :not(:first-child) {
      margin-left: ${isMobile ? '0px' : '8px'};
    }
    :first-child(:only-child) {
      margin-right: ${isMobile ? '0px' : '0px'};
      margin-top: ${isMobile ? '8px' : '0px'};
    }
  `}
`;

export const MobileAlertContainer = styled.div<{ bgColor: string; isOpen: boolean }>`
  align-items: center;
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${({ bgColor }) => bgColor} !important;
  color: #fff;
  justify-content: space-between;
  text-align: center;
  transition: all ease-out 0.3s;
  z-index: 1000;
  padding: 24px 0;

  ${({ isOpen }) =>
    isOpen
      ? css`
          opacity: 1;
          transform: scale(1);
          visibility: visible;
        `
      : css`
          opacity: 0;
          transform: scale(0);
          visibility: hidden;
        `}
`;

export const MobileAlertButton = styled.div<{ bgColor: string; onCancelLabel: boolean }>`
  margin-top: 24px;
  padding: 12px 24px;
  background-color: #fff;
  color: ${(props) => props.bgColor} !important;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  &:hover {
    opacity: 0.9;
  }
`;
export const MobileAlertButtonCancel = styled.button<{ bgColor: string }>`
  margin-top: 24px;
  padding: 12px 24px;
  background-color: ${(props) => props.bgColor} !important;
  color: #fff !important;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;

  &:hover {
    opacity: 0.9;
  }
`;

export const SubMessage = styled.div`
  padding: 0 16px;
  font-size: 16px;
  font-weight: 400;
  margin-top: 8px;
  white-space: pre-line;
  letter-spacing: 0.04px;
`;

export const AlertDescription = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const AlertButtonsContainer = styled.div<{
  isMobile: boolean;
  onCancelLabel: boolean;
}>`
  ${({ isMobile, onCancelLabel }) => css`
    align-items: center;
    box-sizing: border-box;
    display: flex;
    flex-direction: ${isMobile ? 'column-reverse' : 'row'};
    justify-content: center;
    margin-bottom: ${!onCancelLabel && isMobile ? '56px' : '8px'};
    padding: 0px ${isMobile ? '20px' : '0px'};
    width: 100%;
    text-align: center;
  `}
`;

export const CenteredContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding: 0px 44px;
`;
